export default "__VITE_ASSET__eee490fd__"